/* eslint-disable react/jsx-props-no-spreading */
import { ComponentProps, FC } from 'react';
import { Box, Svg, Typography, useThemeValue } from '@altermaind/web/ui';

type DetailItemProps = ComponentProps<typeof Box> & {
  label: string;
  value: string;
  svgName?: ComponentProps<typeof Svg>['name'];
  svgProps?: Omit<ComponentProps<typeof Svg>, 'name'>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  responsive: (props: any) => any;
};

export const DetailItem: FC<DetailItemProps> = ({
  label,
  value,
  svgName,
  svgProps,
  responsive,
  style,
  ...boxProps
}) => {
  const itemGap = parseFloat(`${useThemeValue('sizes', 'xxs')}`);
  return (
    <Box
      display='flex'
      flexDirection={responsive({
        breakPoints: { mobile: 'column' },
        defaultValue: 'row',
      })}
      alignItems='center'
      {...boxProps}
      style={{ gap: itemGap, ...style }}
    >
      {/* eslint-disable-next-line local-rules/no-svg-spread */}
      {svgName && <Svg name={svgName} fill='grey/light' size='xs' {...svgProps} />}
      <Typography variant='p2/light' color='grey/light'>
        {label}
      </Typography>
      <Typography variant='p2'>{value}</Typography>
    </Box>
  );
};
